function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 4.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
}, React.createElement("path", {
  d: "M21.7511 14.7589C32.3156 25.6291 48.5533 28.871 62.528 22.9"
}), React.createElement("path", {
  d: "M40.7175 47.7141C52.8747 47.7141 62.7301 37.9283 62.7301 25.857C62.7301 13.7857 52.8747 4 40.7175 4C28.5603 4 18.705 13.7857 18.705 25.857C18.705 37.9283 28.5603 47.7141 40.7175 47.7141Z"
}), React.createElement("path", {
  d: "M73.4357 76C67.4521 63.4387 54.7119 55.4281 40.7178 55.4281C26.7237 55.4281 13.9836 63.4387 8 76"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 81 81",
    className: "icon",
    style: {
      "height": "1em",
      "width": "1em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/menu-user.c74509b4.svg";
export { SvgComponent as ReactComponent };